import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Product as ProductService } from "../../../services/Catalog Management";

const service = new ProductService();

const REDUCER_MODULE_NAME = "PRICE_LIST";

const initialState = {
  grid: {
    page: 1,
    skip: 0,
    take: 3,
    rows: 0,
    data: [],
    show: 8,
  },
  query: "",
  loading: false,
  message: "",
  error: "",
};

const loadingReducer = (state, _) => {
  return {
    ...state,
    formIsReady: false,
    loading: true,
  };
};

export const grid = createAsyncThunk(
  `GRID_${REDUCER_MODULE_NAME}`,
  async ({ skip, take, currentPage = 1, search = "" }) => {
    const { data } = await service.priceList(skip, take, search);

    return {
      skip,
      take,
      grid: data,
      page: currentPage,
    };
  },
);

/**
 * búsqueda por
 * - codigo
 * - nombre
 *
 * ord:
 * - cod
 * - nombre
 * - precio
 * - cantidad
 * no:
 * - cantidad
 * - precio
 */

export const slice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: {
    [grid.pending.type]: loadingReducer,

    [grid.fulfilled.type]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: "",
        grid: {
          ...state.grid,
          page: action.payload.page,
          skip: action.payload.skip,
          take: action.payload.take,
          rows: action.payload.grid.rows,
          data: action.payload.grid.data,
        },
      };
    },
  },
});

export const { clean } = slice.actions;

export default slice.reducer;
